import React from 'react';
import { StaticImage } from 'gatsby-plugin-image';
import { Box, Heading, Text, Tooltip } from '@chakra-ui/react';
import ImageGallery from 'react-image-gallery';
import { TabType } from './TabNav';
import 'react-image-gallery/styles/css/image-gallery.css';

const IMAGES = [
  {
    original: '../../assets/images/Pricing_table_MEASURE.jpg',
  },
  {
    original: '../../assets/images/Pricing_table_SCALE.jpg',
  },
];

const GallerySection = ({ tab }: { tab: TabType }) => (
  <Box mt="52">
    {tab === 'Membership' && (
      <Heading
        w="100%"
        textAlign="center"
        fontWeight="bold"
        fontSize={['xl', '2xl', '3xl', '4xl']}
        mb="10"
        px={['10', '16', '32']}
      >
        Which plan is right for for you?
      </Heading>
    )}

    <Text w="100%" textAlign="center" mb={['16', '20']} fontSize="2xl" px="5">
      Each property is priced based on the number of roof facets.{' '}
      <Tooltip
        placement="top"
        background="hoverBlue"
        borderRadius="5"
        padding="2"
        label="A facet is a single, uninterrupted plane on the roof. Each separate flat section counts as a facet."
      >
        <Text as="span" fontSize="lg">
          ⓘ
        </Text>
      </Tooltip>
    </Text>

    <Box maxW="4xl" mx="auto" mb="14" px="5">
      {tab === 'Membership' ? (
        <ImageGallery
          items={IMAGES}
          lazyLoad
          showPlayButton={false}
          showFullscreenButton={false}
        />
      ) : (
        <StaticImage
          src="../../assets/images/Pricing_table_MEASURE-3.png"
          alt="pay as you go pricing per property"
        />
      )}
    </Box>

    <Text textAlign="center" px="5" fontSize="lg" mb="32">
      Any property can be expedited for an additional fee. Please see the table
      below.
    </Text>
  </Box>
);

export default GallerySection;
